import { ClientView, Method2FA } from 'enums';

export interface AdditionalInfoData {
  title: string;
  signatureLocation: string;
  clientView: ClientView;
  meetingRecordNote: string;
  notification: {
    notificationMonthlyStatement: boolean;
    notificationYearlyStatement: boolean;
    ltipSummary: boolean;
    newPayment: boolean;
    paymentSent: boolean;
    targetClose: boolean;
    targetWithdrawal: boolean;
    depositDue: boolean;
    depositClose: boolean;
    portfolioUpdate: boolean;
  };
  use2fa: boolean;
  method?: Method2FA;
  options: {
    method: Method2FA[]
  }
}

export const initialValues = {
  title: '',
  signatureLocation: '',
  clientView: '',
  meetingRecordNote: '',
  notification: {
    notificationMonthlyStatement: true,
    notificationYearlyStatement: true,
    ltipSummary: true,
    newPayment: true,
    paymentSent: true,
    targetClose: true,
    targetWithdrawal: true,
    depositDue: true,
    depositClose: true,
    portfolioUpdate: true
  },
};
